import React from 'react';
import './CourseExcerpt.less';
import Button from '../../../common/js/app/Button/Button.jsx';
import { Row, Column } from 'react-plan';
import { Link } from 'react-router';

type Props = {

}

const strings = {
  detail: 'See detail'
};

class CourseExcerpt extends React.Component {

  description: 'Displays an excerpt widget of a course.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="m-b-xl p-t p-b course-excerpt">
        <Row>
          <Column className="m-b" size="33%" small="100%" medium="hide" large="hide" wide="hide" align="center">
            <img alt={ this.props.course.title } className="img-responsive ie-fix-size" src={ this.props.course.cover } />
          </Column>
          <Column className="p-r m-b" size="60%" small="100%">
            <h3>{ this.props.course.title }</h3>
            <p className="m-t m-b">{ this.props.course.excerpt }</p>
            <Link className="no-underline" to={ `course/${this.props.course.id}` } >
              <Button>{ strings.detail }</Button>
            </Link>
          </Column>
          <Column className="p-l m-b" size="33%" small="hide" align="center">
            <img alt={ this.props.course.title } className="img-responsive ie-fix-size" src={ this.props.course.thumbs } />
          </Column>
        </Row>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default CourseExcerpt;

//Unit test entry point
export const CourseExcerptTest = CourseExcerpt;


/** WEBPACK FOOTER **
 ** ./src/js/course/CourseExcerpt/CourseExcerpt.jsx
 **/